import * as React from 'react';
import s from './PaymentBrandLogo.scss';
import classNames from 'classnames';
export var PaymentBrandLogo = function (_a) {
    var cardBrand = _a.cardBrand, _b = _a.size, size = _b === void 0 ? 'small' : _b;
    return (React.createElement("div", { "data-hook": "payment-method-logo-".concat(cardBrand), className: classNames("".concat(s[cardBrand.toUpperCase()]), s[size]) }));
};
//# sourceMappingURL=PaymentBrandLogo.js.map